import { v4 as uuidv4 } from 'uuid'
import { Renderer } from '@/Renderer'
import VectorLayer from 'ol/layer/Vector'
import _ from 'lodash'
import WaypointFeature from './WaypointFeature'
import WaypointFeatureSource from './WaypointFeatureSource'
import WaypointSerialization from './WaypointSerialization'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import { createOrUpdate, createOrUpdateFromCoordinate } from 'ol/extent'

interface HistoryStackItem {
    dotLngLats: WaypointSerialization[];
}

export class WaypointsEntity {
    static nextId = 1

    value = uuidv4()
    totalDistance = 0

    dotLngLats: WaypointSerialization[] = []
    layers: VectorLayer<VectorSource<any>>[] = []
    history: HistoryStackItem[] = []
    
    dotsFeatureSource = new WaypointFeatureSource({ features: [] })
    renderer: Renderer<any> | null = null
    type = 'track'
    
    saveFeaturesToLngLats(renderer: Renderer<any>) {
        this.dotLngLats = this.dotsFeatureSource.getFeatures().map((feature) => new WaypointSerialization(feature.value, feature.props, renderer.TransformPointToLatLngCoordinates(feature.getGeometry()!))) 
    }

    preUndo(renderer: Renderer<any>) {
        this.saveFeaturesToLngLats(renderer)
        this.history.push({
            dotLngLats: this.dotLngLats,
        })
    }

    doUndo(renderer: Renderer<any>) {
        const historyItem = this.history.pop()
        if(historyItem) {
            this.dotLngLats = historyItem.dotLngLats
            this.loadFeaturesFromLngLats(renderer)
        }
    }

    loadFeaturesFromLngLats(renderer: Renderer<any>) {
        this.renderer = renderer
        this.dotsFeatureSource.clear()
        this.dotsFeatureSource.addFeatures(this.dotLngLats.map((point, index) => new WaypointFeature(renderer.TransformPointFromLatLng(new Point(point.latLngCoords)), this, index, point.props))) 
    }

    isDegenerate() {
        return this.dotsFeatureSource.getFeatures().length === 0
    }
}